import { Group, Label, Layer, Path, Tag, Text } from 'react-konva';
import type { RemotePresence } from '@system-atlas/shared';

/** Zeiger-Form (Pfeilspitze) in Bildschirm-Pixeln; per 1/scale zoom-invariant gehalten. */
const CURSOR_PATH = 'M 0 0 L 0 16 L 4.5 12.5 L 7.5 19 L 10 18 L 7 11.5 L 12 11 Z';

/**
 * Cursor + Namen der anderen Teilnehmer (Spec Abschnitt 6) auf eigener,
 * nicht-interaktiver Konva-Ebene. Wird beim Export NICHT gerendert
 * (Einbindung im EditorCanvas steht hinter der !exporting-Bedingung).
 */
export function RemoteCursorsLayer({ cursors, scale }: { cursors: RemotePresence[]; scale: number }) {
  const s = 1 / scale;
  return (
    <Layer listening={false}>
      {cursors.map((c) =>
        c.cursor ? (
          <Group key={c.clientId} x={c.cursor.x} y={c.cursor.y} scaleX={s} scaleY={s}>
            <Path data={CURSOR_PATH} fill={c.color} stroke="#ffffff" strokeWidth={1} />
            <Label x={12} y={16}>
              <Tag fill={c.color} cornerRadius={3} />
              <Text text={c.name} fontSize={11} fill="#ffffff" padding={3} />
            </Label>
          </Group>
        ) : null,
      )}
    </Layer>
  );
}
